// extracted by mini-css-extract-plugin
module.exports = {"chat-container":"ChatContainer_chat-container__-sVDe","chat-container-inner":"ChatContainer_chat-container-inner__3nTc3"};